import React from 'react'

import cx from 'classnames'

import styles from './style.module.css'

interface Props {
  circle?: boolean
  count: number
  dot?: boolean
}

const Badge: React.FC<Props> = ({ count, circle = false, dot = false }) => (
  <div
    className={cx(styles.badge, {
      [styles.circle]: circle,
      [styles.dot]: dot,
    })}>
    {dot ? '' : count}
  </div>
)

export default Badge
